export enum MapProviderType {
  OpenStreetMap = 'OpenStreetMap',
  RasterOnly = 'RasterOnly',
  RasterWithOpenStreetMap = 'RasterWithOpenStreetMap',
  ArcGIS = 'ArcGIS',
  GeoServer = 'GeoServer',
}

export interface MapProviderModel {
  providerType: MapProviderType;
  uri: null | string;
  layerName: null | string;
  maxZoom: number;
  maxNativeZoom: number;
}
